<template>
  <main class="main inside-page cabinet-page text-page">
    <div class="main-wrapper">
      <div class="section hero-section">
        <div class="page-inside-top">
          <transition name="fade">
            <div v-if="textPageTitle" class="wrapper">
              <div class="title small">
                <span>{{ textPageTitle }}</span>
              </div>
              <div class="desc-container static-content">
                <div class="desc" v-html="sanitizedContent" />
              </div>
            </div>
          </transition>
        </div>
      </div>
    </div>
  </main>
</template>
<script>
export default {
  name: "TextPage",
  components: {},
  props: [],
  data: function () {
    return {
      textPageTitle: "",
      textPageHeader: "",
      textPageContent: "",
    };
  },
  watch: {
    $route() {
      if (this.$route.params.id) {
        this.getTextPageContent(this.$route.params.id);
      } else {
        this.$http.get("static-pages").then((res) => {
          let newList = res.data.payload;
          let newItem = newList.filter(
            (item) =>
              item.title.replace(/ /g, "_").toLowerCase() ==
              this.$route.params.title
          );
          this.getTextPageContent(newItem[0].id);
        });
      }
    },
  },
  mounted() {
    if (this.$route.params.id) {
      this.getTextPageContent(this.$route.params.id);
    } else {
      this.$http.get("static-pages").then((res) => {
        let newList = res.data.payload;
        let newItem = newList.filter(
          (item) =>
            item.title.replace(/ /g, "_").toLowerCase() ==
            this.$route.params.title
        );
        this.getTextPageContent(newItem[0].id);
      });
    }
  },
  methods: {
    getTextPageContent(id) {
      this.textPageTitle = "";
      this.textPageHeader = "";
      this.textPageContent = "";
      this.$http
        .get("static-pages/" + id)
        .then((res) => {
          this.textPageTitle = res.data.payload.title;
          this.textPageContent = res.data.payload.content;
          this.textPageHeader = res.data.payload.header;
        });
    },
  },
  computed: {
    sanitizedContent() {
      if (!this.textPageContent) return "";

      let content = this.textPageContent;

      // Remove all inline style, class, and alignment attributes
      content = content.replace(/style="[^"]*"/gi, "");
      content = content.replace(/class="[^"]*"/gi, "");
      content = content.replace(/align="[^"]*"/gi, "");
      content = content.replace(/lang="[^"]*"/gi, "");

      // Replace common HTML entities for better readability
      content = content
        .replace(/&nbsp;/g, " ")
        .replace(/&ldquo;/g, '"')
        .replace(/&rdquo;/g, '"')
        .replace(/&lsquo;/g, "'")
        .replace(/&rsquo;/g, "'");

      // Wrap tables for horizontal scrolling on mobile
      content = content.replace(
        /<table/gi,
        '<div class="table-scroll-wrapper"><table'
      );
      content = content.replace(/<\/table>/gi, "</table></div>");

      return content;
    },
  },
};
</script>
<style lang="scss" scoped>
.static-content {

  // Use ::v-deep to pierce scoped CSS and style the v-html content.
  ::v-deep {

    // Universal reset for elements coming from the API.
    * {
      font-family: inherit !important;
      font-size: inherit !important;
      line-height: inherit !important;
      color: inherit !important;
      background: none !important;
      margin: 0;
      padding: 0;
    }

    // Consistent spacing for block elements
    p,
    ul,
    ol,
    .table-scroll-wrapper,
    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
      margin-bottom: 1.25rem;
    }

    p {
      line-height: 1.6;
    }

    // Consistent styles for headings
    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
      font-weight: bold;
      margin-top: 2rem;
      line-height: 1.3;
    }

    h1 {
      font-size: 2rem;
    }

    h2 {
      font-size: 1.75rem;
    }

    h3 {
      font-size: 1.5rem;
    }

    strong,
    b {
      font-weight: bold;
    }

    // Correct styling for lists
    ul,
    ol {
      padding-left: 1.5rem; // Indentation for bullets/numbers
    }

    // Fix gap between paragraph and list
    p+ul,
    p+ol {
      margin-top: -1rem;
    }

    ul {
      list-style: disc outside;
    }

    ol {
      list-style: decimal outside;
    }

    li {
      margin-bottom: 0.75rem;
      line-height: 1.6;
      padding-left: 0.5rem;
    }

    // Table styles for consistency and responsiveness
    .table-scroll-wrapper {
      overflow-x: auto;
    }

    table {
      width: 100%;
      min-width: 600px;
      border-collapse: collapse;
    }

    th,
    td {
      border: 1px solid rgba(255, 255, 255, 0.2);
      padding: 0.75rem;
      text-align: left;
      color: white !important;
    }

    th {
      font-weight: bold;
      background-color: rgba(255, 255, 255, 0.05);
    }

    a {
      color: #ed59e3;
      text-decoration: underline;

      &:hover {
        text-decoration: none;
      }
    }
  }
}
</style>